import { clearTokens, getAccessToken, setTokens } from '@api';
import { storage } from '@core/storage';

const AUTH_TOKEN_KEY = 'token';

export const setAuthToken = (token: string): void => {
  storage.set(AUTH_TOKEN_KEY, token);
  // Sync with REST API client storage (access_token)
  // Note: refresh token might not be available here, preserve existing
  const existingRefresh = localStorage.getItem('refresh_token') || '';
  setTokens(token, existingRefresh);
};

export const getAuthToken = (): string | null => {
  try {
    // Try REST API storage first (access_token), fallback to legacy (token)
    return getAccessToken() || storage.get(AUTH_TOKEN_KEY);
  } catch {
    return null;
  }
};

export const removeAuthToken = (): void => {
  storage.remove(AUTH_TOKEN_KEY);
  clearTokens(); // Also clear REST API tokens
};
